import React, { useState } from "react";
import { RxEnter } from "react-icons/rx";

const NSWhatsapp_orderStatusChange = ({ orderId, WAPtoken, orderStatus }) => {
  // console.log(orderId)
  // const [orderEditId, setOrderEditId] = useState("");
  const [newStatus, setNewStatus] = useState(""); 

  const statusOptions = [
    // "Ordered",
    "Dispatched",
    "Out for Delivery",
    "Delivered",
  ];

  const handleChangeStatus = async (event) => {
    event.preventDefault();
    try {
      const orderEditData = {
        order_status: newStatus,
      };

      const response = await fetch(
        `https://vaaradhi-dev.agrani.tech/commgrid/api/orders/${orderId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${WAPtoken}`,
          },
          body: JSON.stringify(orderEditData),
        }
      );

      if (response.ok) {
        // Status change successful
        console.log("Order edit status changed successfully");
      } else {
        // Handle error if status change failed
        console.error("Failed to change order edit status");
      }
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      window.location.reload();
    }, 30);
    return false;
  };

  return (
    <div className="d-flex justify-content-around">
      <select
        className="form-control"
        style={{ width: "150px", fontSize: "13px" }}
        value={newStatus}
        onChange={(e) => setNewStatus(e.target.value)}
      >
        <option value="" className="">
          {orderStatus}
        </option>
        {statusOptions
          .filter((status) => orderStatus !== status)
          .map((status) => (
            <option key={status} value={status}>
              {status}
            </option>
          ))}
      </select>
      <button
        type="button"
        onClick={handleChangeStatus}
        className="text-wrap btn btn-warning bold ml-2"
      >
        <small style={{ fontSize: "12px" }}>
          <RxEnter></RxEnter>
        </small>
      </button>
    </div>
  );
};

export default NSWhatsapp_orderStatusChange;
